import { CarouselItem } from '../../../core/models/item';
import { KeywordJsEnv } from './keyword_js_env';

/** 画面表示に必要なデータを管理する人 */
export class Keyword {
  constructor(private model: KeywordJsEnv) {
    this.model = { ...model };
    // rrAreaに表示するItemsとTttleは外部公開APIとRRサーバで取得するのでここは空で定義
    this.model.rrAreaProfileKeywordNormal = {
      placementName: model.isEmptySearchResult ? 'recomRR_NASearch_01' : 'recomRR_Search_01',
      displayCount: 3,
      rrAreaItems: [],
      rrAreaTitle: '',
      perView: 5
    };
    this.model.rrAreaProfileKeywordLeftSide = {
      placementName: 'recomRR_Search_02',
      rrAreaItems: [],
      rrAreaTitle: ''
    };

    this.model.rrAreaProfileKeywordSp = {
      placementName: 'recomRR_SP_Search_01',
      displayCount: 4,
      rrAreaItems: [],
      rrAreaTitle: ''
    };
  }

  getModel(): KeywordJsEnv {
    return this.model;
  }

  setRrAreaDataKeywordNormal(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileKeywordNormal.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileKeywordNormal.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataKeywordLeftSide(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileKeywordLeftSide.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileKeywordLeftSide.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataKeywordSp(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileKeywordSp.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileKeywordSp.rrAreaTitle = rrAreaTitle;
  }

  setPublishedPage(input: string): void {
    this.model.publishedPage = input;
  }

  updateHtmlForRender(htmlForRender: Document) {
    this.model.htmlForRender = htmlForRender;
  }

  updateBaloonId(baloonId: string) {
    this.model.baloonId = baloonId
  }
}
